module.exports = __webpack_public_path__ + "img/588x310-01.5b56cd42.png";